<template>
    <div id="app">
        <Heade>
            <template v-slot:back ><img src="../../assets/img/02-2左new.png" alt="" @click="$router.push('/jizhenkeVedio')"></template>
            <template v-slot:title>视频播放</template>
        </Heade>
        <div class="video">
            <div class="prism-player" id="player-con" style="height:202px"></div>
            <div class="transmitNumber" v-show="isTransmitNumber">
                <img src="../../assets/img/bofang.png" alt="">
                <span>{{transmitNumber}}</span>
            </div>
        </div>
        <div class="myTab">
            <div class="intro flex">
                <span class="xuansong">作品介绍：</span><span :class="titleOpen ? 'spanPull' : 'span' ">{{spDetail.text_desc}}</span>
                <div @click="titleOpenClick()"><img v-if="!titleOpen" src="../../assets/img/down.png"/> <img v-if="titleOpen" src="../../assets/img/pull.png"/></div>
            </div>
            <div class="intro flex">
                <span class="xuansong">选送单位：</span><span class="xuansongtext">{{spDetail.origin ? spDetail.origin: ''}} {{spDetail.department ? spDetail.department : ''}}</span>
            </div>
            <div class="playData flex">
                <div class="flex square">
                    <div class="imgBox one"><img src="../../assets/img/spjs_1.png"/></div>
                    <div>{{spDetail.forward_num ? spDetail.forward_num : 0}} 次转发</div>
                </div>  
                <div class="flex square">
                    <div class="imgBox short"><img src="../../assets/img/spjs_2.png"/></div>
                    <div>{{spDetail.vote_num ? spDetail.vote_num : 0}} 票</div></div>  
                <div class="flex square">
                    <div class="imgBox"><img src="../../assets/img/spjs_3.png"/></div>
                    <div>{{spDetail.praise_num ? spDetail.praise_num : 0}} 赞</div>
                </div>
            </div>
            <!-- <div class="paiming">当前排名{{spDetail.paiming}}，距离上一名票数{{spDetail.lessThenPreviousVoteNum}}票</div> -->
            <div class="vote flex">
                <div class="voteBtn flex" @click="dianZanClick">
                    <div class="imgBoxsp"><img v-if="spDetail.canDianZan" src="../../assets/img/zanGrey.png"/><img v-if="!spDetail.canDianZan" src="../../assets/img/zan.png"/></div>
                    <div class="col"> <div class="tit">为TA点赞</div></div>  
                </div>
                <div class="voteBtn flex" @click="voteClick">
                    <div class="imgBoxsp"><img v-if="spDetail.canTouPiao" src="../../assets/img/voteGrey.png"/><img v-if="!spDetail.canTouPiao" src="../../assets/img/vote.png"/></div>
                    <div class="col"> 
                        <div class="tit">为TA投票</div>
                        <!-- <div class="tip">您的票数：0</div>  -->
                    </div>
                </div>
            </div>
        </div>
        <div class="myTab marginTop">
            <div class="more">想了解更多急先锋项目?</div>
            <div class="bgimg"><div class="codeimg"></div></div>
            <div class="guanzhu">请关注微信公众号</div> 
            <div class="zhuanlanBox">
                <div class="zhuanlan">点击“急先锋”专栏</div>
                <div class="zlImg"><img src="../../assets/img/dianji.png"/></div>
            </div>
            <div class="line"></div>
            <div class="introdesc">
                “急先锋”项目旨在联合全国各级医疗单位实施以“上下联动”为中心的医疗技术帮扶、教育服务，围绕以急诊为平台的医院“五大中心”建设工作重点，从胸痛中心建设、卒中新进展等方面进行探讨，结合临床指南和规范，开展临床技能和知识培训，提高基层医生临床诊疗水平，为推动建成快速、高效一体化的急危重症医疗救治体系，做出一份贡献。
            </div>
        </div>

        <!--去关注-->
        <div class="selectHuiyi" v-if="quguanzhu">
            <div class="MengchengBg"></div>
            <div class="Mengcheng_con">
                <div class="Mengcheng_top">
                    <div>提示</div>
                </div>
                <div id="mySelectHuiyi">
                <div class="text">您还没有关注公众号,请先关注！</div>
                </div>
                <div class="selectHuiyiJX" @click="quguanzhuClick">去关注</div>
            </div>
        </div>

    </div>
</template>
<style>
    .video-dimensions {
        width: 100%;
    }
</style>

<script>
    var wx = require('weixin-js-sdk');
    import { Toast } from "vant";
    export default {
        data(){
            return {
                message: 3,
                isShow: true,
                meeting_field: '',//会议场次
                id: '',//会议id
                video_id: '',//视频ID
                schedule_url: '',//日程表地址
                video_cover_url: '',//视频封面
                CommentList: [],//评论列表
                num: 0,
                arr: [],
                isLoad: false,
                transmitNumber: 0,//播放数量
                isTransmitNumber: true,
                curHeight: 0,
                spId: '',
                quguanzhu: false,
                subScribeUrl: '',
                nummm: 0,
                spDetail: [],
                titleOpen: true
            }
        },
        mounted() {
            var weiCode = this.getQueryString("code");
            let spId = location.href.split('=')[location.href.split('=').length-1]
            let Url =  location.href.split('?')[0] 
            Url = `${Url}?spId=${spId}`;
            let shareUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcc0a796f6b6cfa33&redirect_uri=${encodeURIComponent(Url)}&res&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect`
            
            if (weiCode == "null" || weiCode == "" || weiCode == null) {

                window.location.href = shareUrl
                console.log("新code",weiCode, location.href)

            }else{
                const openId = this.$store.state.openId
                console.log("新页面",weiCode,location.href)
                if(this.$route.query.video_id){   
                    if(openId == "null" || openId == "" || openId == null){
                        this.id = location.href.split('=')[location.href.split('=').length-1]
                        this.getOpenid(weiCode);
                    }else{                                        
                        this.meeting_field = this.$route.query.meeting_field;
                        this.id = this.$route.query.id;
                        this.video_id = this.$route.query.video_id; 
                        this.shareDetail();
                    }
                }else{                        
                    this.id = location.href.split('=')[location.href.split('=').length-1]
                    this.getOpenid(weiCode);
                }
                this.connectWx();
            }
        },
        methods: {
            titleOpenClick(){
                this.titleOpen = !this.titleOpen
            },
            dianZanClick(){
                const url = "/jxf/videoPraiseRecord";
                let params = {
                    jxfVideoRecordId: this.id,
                    openId: this.$store.state.openId
                }
                this.axios.post(url,params,
                { transformRequest: function (params) {return JSON.stringify(params);},
                headers: {'Content-Type': 'application/json;charset=UTF-8'}
                }).then(res => {
                    if (res.data.code === "00000") {   
                        Toast(res.data.msg);
                        this.shareDetail()
                    }else{
                        Toast(res.data.msg);
                    }
                });
            },
            voteClick(){
                const url = "/jxf/videoVoteRecord";
                let params = {
                    jxfVideoRecordId: this.id,
                    openId: this.$store.state.openId
                }
                this.axios.post(url,params,
                { transformRequest: function (params) {return JSON.stringify(params);},
                headers: {'Content-Type': 'application/json;charset=UTF-8'}
                }).then(res => {
                    if (res.data.code === "00000") {   
                        Toast(res.data.msg);
                        this.shareDetail()
                    }else{
                        Toast(res.data.msg);
                    }
                });
            },
            guanzhu(){
                const url = "/jxf/getUserIfSubScribe";
                let params = {
                    openId:this.$store.state.openId
                }
                this.axios.post(url,params,
                { transformRequest: function (params) {return JSON.stringify(params);},
                headers: {'Content-Type': 'application/json;charset=UTF-8'}
                }).then(res => {
                    if (res.data.code === "00000") {   
                        const data = res.data.model
                        if(data.subScribe){
                            this.shareDetail();
                        }else{
                            this.quguanzhu = true
                            this.subScribeUrl = data.subScribeUrl
                        }
                    }
                });
            },
            quguanzhuClick(){
                window.location.href = this.subScribeUrl
            },
            //分享页面获取详细信息
            shareDetail(){
                const url = "/jxf/getVideoRecordInfo";
                let params = {
                    jxfVideoRecordId: this.id,
                    openId: this.$store.state.openId
                }
                this.axios.post(url,params,
                { transformRequest: function (params) {return JSON.stringify(params);},
                headers: {'Content-Type': 'application/json;charset=UTF-8'}
                }).then(res => {
                    if (res.data.code === "00000") {   
                        this.spDetail = res.data.model
                        this.video_cover_url = this.spDetail.video_cover_url;
                        this.transmitNumber = this.spDetail.view_num > 9999 ? (this.spDetail.view_num / 10000).toFixed(1) + '万' : this.spDetail.view_num;
                        // this.video_id = res.data.model.video_id
                        this.playVideo(this.spDetail.video_id);
                        this.connectWx();
                    }
                });
            },
            connectWx(){
                const url = "/jxf/getSiginConfig";
                let params = {
                    configUrl:location.href.split('#')[0]
                }                    
                this.axios.post(url,params,
                { transformRequest: function (params) {return JSON.stringify(params);},
                headers: {'Content-Type': 'application/json;charset=UTF-8'}
                }).then(res => {
                    if (res.data.code === "00000") { 
                        const _this = this;  
                        let datad = res.data.model        
                        wx.config({
                　　　　　　debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
                　　　　　　appId: datad.appId, // 必填，公众号的唯一标识
                　　　　　　timestamp: datad.timestamp, // 必填，生成签名的时间戳
                　　　　　　nonceStr: datad.nonceStr, // 必填，生成签名的随机串
                　　　　　　signature: datad.signature,// 必填，签名，见附录1
                　　　　　　jsApiList: [
                　　　　　　　　"onMenuShareAppMessage",'onMenuShareTimeline'
                　　　　　　] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                　　　　});
                        wx.ready(function () {   //需在用户可能点击分享按钮前就先调用 
                            let Url =  location.href.split('?')[0]    
                            let spId = location.href.split('=')[location.href.split('=').length-1]
                            Url = `${Url}#/jizhenkePlay?spId=${spId}`;
                            // let imgUrl = 'http://qxts.oss-cn-zhangjiakou.aliyuncs.com/img/jxflogo.112ea0c8.png'
                            let imgUrl = _this.video_cover_url
                            let descCon = '急诊科的故事评选开始啦！快来pick出您心中最最喜爱的急诊科故事!'
                            let titledesc = '快来为“'+ _this.spDetail.origin + _this.spDetail.department +'”加油，为优秀视频点赞投票吧!'
                            // let shareUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcc0a796f6b6cfa33&redirect_uri=${encodeURIComponent(Url)}&res&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
                            wx.onMenuShareAppMessage({ 
                                title: titledesc, // 分享标题
                                desc: descCon, // 分享描述
                                link: Url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl:  imgUrl, // 分享图标
                                success: function () {
                                    // 设置成功
                                    console.log("自定义分享成功回调！")
                                    _this.countNum();
                                    _this.shareDetail()
                                }
                            })
                            wx.onMenuShareTimeline({ 
                                title: titledesc, // 分享标题
                                desc: descCon, // 分享描述
                                link: Url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: imgUrl, // 分享图标
                                success: function () {
                                    // 设置成功
                                    console.log("自定义分享成功回调！")
                                    _this.countNum();
                                    _this.shareDetail()
                                }
                            })                                
                        });
                　　　　wx.error(function (res) {
                　　　　　　console.log("接入微信",res);
                　　　　});
                    }
                });
                
            },
            countNum(){
                const url = "/jxf/videoForwardRecord";
                let params = {
                    jxfVideoRecordId: this.id,
                    openId: this.$store.state.openId
                }
                this.axios.post(url,params,
                { transformRequest: function (params) {return JSON.stringify(params);},
                headers: {'Content-Type': 'application/json;charset=UTF-8'}
                }).then(res => {
                    if (res.data.code === "00000") {   
                        this.nummm++
                    }
                });
            },
            //播放视频。
            playVideo(videoId) {
                const _this = this;
                this.axios.post("/api/video/getAliyunVideoPlayAuth", { videoId: videoId }).then(res => {
                    let data = res.data
                    if (data.code === "00000") {
                        // console.log(data.model.playAuth);
                        // console.log(data.model.coverUrl);

                        var player = new Aliplayer({
                            "id": "player-con",
                            "vid": videoId,
                            "playauth": data.model.playAuth,
                            "cover": data.model.coverUrl,
                            "width": "100%",
                            "height": "433px",
                            "autoplay": false,
                            "isLive": false,
                            "rePlay": false,
                            "playsinline": true,
                            "preload": true,
                            "controlBarVisibility": "hover",
                            "useH5Prism": true
                        }, function (player) {
                            // console.log("The player is created");
                            // player.play();
                            player.on('play', function (e) {
                                // console.log('播放开始')
                                _this.isTransmitNumber = false;
                            });
                        }
                        );

                    } else {
                        alert("获取播放授权码错误，请返回重试。");
                    }
                })
            },
            //获取视频地址图片地址
            checkJson(str) {
                if (typeof str == 'string') {
                    try {
                        var obj=JSON.parse(str);
                        if(typeof obj == 'object' && obj ){
                            return true;
                        }else{
                            return false;
                        }

                    } catch(e) {
                        return false;
                    }
                }
            },
            
            //返回
            goBack() {
                this.$router.push('/jizhenkeVedio')
                // window.location.href = "./playbackList.html";
            },
            //配置video
            setVideo() {
                var options = {
                    controls: 'control',
                    preload: 'none',
                    height: '422',
                };
                var player = videojs('video', options)

                //待切换的视频源
                var newVideo = this.path;
                //console.log(newVideo,'666666')
                //暂停视频
                player.pause()
                //获取视频节点（也就是video元素）
                //值的注意的是，想通过id或者class获取该节点的时候，要注意video前后渲染的时候id和class改变了
                //请使用渲染后的id或者class
                //比如，这个原来的id是video，渲染后变成了video1_html5_api
                var $video = $('video_html5_api')
                $video.attr('src', newVideo)
                //重载视频
                player.load()
                //开始视频
                player.play()
            },
            //处理地址
            getQueryString(name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
                var r = window.location.search.substr(1).match(reg);
                if (r != null) return unescape(r[2]);
                return null;
            },
            getOpenid(weiCode) {
                console.log("获取openid",weiCode)  
                const _this = this;
                const url = "/queryWeiXin";
                var xhr = new XMLHttpRequest();
                xhr.open("post", "https://rhgt.api.anlongmaide.com" + url, true);
                xhr.setRequestHeader(
                    "Content-type",
                    "application/x-www-form-urlencoded;charset=UTF-8"
                );
                var data = { code: weiCode };
                let ret = "";
                for (const it in data) {
                    ret +=
                    encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
                }
                xhr.send(ret);
                xhr.onreadystatechange = function() {
                    if (xhr.status == 200 && xhr.readyState == 4) {
                    const data = JSON.parse(xhr.responseText);
                    if (data.weixin) {
                        sessionStorage.setItem("openid", data.weixin);
                        _this.$store.commit("setOpenId", data.weixin);
                    } else {
                        let urlQian =  location.href.split('?')[0]                            
                        let urlHou = location.href.split('#')[location.href.split('#').length-1]
                        let Url = `${urlQian}#${urlHou}`;
                        let shareUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcc0a796f6b6cfa33&redirect_uri=${encodeURIComponent(Url)}&res&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect`
                        window.location.href = shareUrl
                    }
                    console.log("store微信openid",_this.$store.state.openId)                        
                    _this.guanzhu();
                    }
                };
            },
        },
        watch: {
            nummm(val){
                console.log("转发数量",val)  
            }
        }
    }
</script>
<style lang="less" scoped>
html,body{
    background: #f2f2f2;
    overflow-x: hidden!important;
}
div{ box-sizing: border-box; }
.paiming{
    margin-top: 20px;
    color: #2D5FA7;
    font-size: 30px;
}
.flex{
  display: flex; 
  flex-direction: row;
  font-size: 24px;
  align-items: center; 
  .square{
      margin-right: 45px;
  }
  .imgBox{
    width: 30px;
    height: 30px;
    margin-right: 8px;
    img{
        width: 100%;
      }
    }
   .imgBoxsp{
     width: 30px;
     margin-right: 30px;
     img{
        width: 100%;
     }
    }
}
.intro{
    position: relative;
    font-size: 30px;
    margin-bottom: 40px;
    align-items: flex-start;
    img{
        position: absolute;
        width: 25px;
        height: 15px;
        right: 0;
        top: 12px;
    }
    .span{
        display: block;
        width: 80%;        
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .spanPull{
        width: 80%;
    }
    .xuansong{
        width: 160px;
        font-weight: bold;
    }
    .xuansongtext{
        width: 70%;
    }
    
}
.vote{
    margin-top: 44px;
    display: flex; 
    justify-content: space-between;
    .voteBtn{
        width: 280px;
        height: 108px;        
        background: #F3F3F3;
        border-radius: 4px;
        justify-content: center;
        font-size: 30px;
        .tip{
            font-size: 18px;
            color: #666;
        }
    }
}
.title{
    width: 100%;
    height: 82px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    position: relative;
    .back{
        position: absolute;
        top: 20px;
        left: 30px;
        img{
            width: 15px;
            height: 26px;
        }
    }
}
.video{
    width: 100%;
    // height: 422px;
    background: #ffffff;
    position: relative;
    .transmitNumber{
        position: absolute;
        top: 22px;
        right: 30px;
        font-size: 24px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
        img{
            margin-right: 12px;
        }
    }
}
.myTab{
    width: 100%;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    margin: 0;
    padding: 36px 30px;
  
}

/deep/.prism-big-play-btn{
    left: 42%!important;
    bottom: 35%!important;
}
/deep/.prism-player .prism-cover{
    z-index: 0;
}
.selectHuiyi {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .MengchengBg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.3;
    z-index: -1;
  }
  .Mengcheng_con {
    width: 520px;
    height: 400px;
    background-color: white;
    border-radius: 20px;
    margin: auto;
    margin-top: 50%;
    .Mengcheng_top {
      width: 100%;
      height: 140px;
      border-radius: 8px 8px 0 0;
      /* background: url("../../images/qt/landi.png") no-repeat center; */
      background: #007aff;

      background: -webkit-linear-gradient(left top, #78c4ff, #007aff);

      background: -moz-linear-gradient(left top, #78c4ff, #007aff);

      background: -ms-linear-gradient(left top, #78c4ff, #007aff);

      background: -o-linear-gradient(left top, #78c4ff, #007aff);

      background: linear-gradient(to left top, #78c4ff, #007aff);
      background-size: 100% 100%;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      img {
        width: 77px;
        height: 12px;
      }
      div {
        font-size: 36px;
        color: white;
        margin-top: 10px;
      }
    }
    #mySelectHuiyi {
      height: 300px;
      overflow: auto;
      background-color: white;
      .text{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        box-sizing: border-box;
        padding:0 30px;
        letter-spacing: 5px;
      }
    }
    .selectHuiyiJX {
      width: 100%;
      height: 88px;
      font-size: 32px;
      color: white;
      background-color: #1d8eff;
      border-radius: 0 0 20px 20px;
      text-align: center;
      line-height: 85px;
    }
  }
}
.marginTop{
    margin-top: 10px;
    align-items: center;
    .more{        
        font-size: 34px;
        font-weight: bold;
        color: #2D5FA7;
    }
    .bgimg{
        background-image: url("../../assets/img/bgimg.png");
        background-size: 100%;
        width: 274px;
        height: 274px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 50px 0 45px;
        .codeimg{
            background-image: url("../../assets/img/codeimg.png");
            background-size: 100%;
            width: 222px;
            height: 222px;
        }
    }
    .guanzhu{        
        font-size: 28px;
        font-weight: 400;
        color: #333333;
    }
    .zhuanlanBox{
        position: relative;
        margin: 24px 0 43px;
    }
    .zhuanlan{
        width: 317px;
        height: 60px;
        background: #2D5FA7;
        border-radius: 30px;        
        font-size: 26px;
        color: #FFFFFF;
        text-align: center;
        line-height: 60px;
    }
    .zlImg{
        position: absolute;
        top: 26px;
        right: -46px;
        width: 69px;
        height: 59px;
        img{
            width: 100%;
        }
    }
    .line{
        width: 100%;
        height: 2px;
        border: 1px dashed #2D5FA7;
        margin-bottom: 40px;
    }
    .introdesc{        
        font-size: 26px;
        color: #333333;
        line-height: 36px;
        text-indent:40px;
    }
}
</style>